import { Prompt, PromptInput } from '../../../../../../services/backendService/types';
import { Slide } from '../../../../../SlideComponents/slide.types';
import { flattenPromptOutputs, PromptOutputAndNameId } from '../nodes/generateAllNodes';
import generatePromptInputToPromptEdges from './generatePromptInputToPromptEdges';
import generatePromptOutputToPromptEdges from './generatePromptOutputToPromptEdges';
import generatePromptOutputToSlideEdges from './generatePromptOutputToSlideEdges';
import generatePromptToPromptOutputEdges from './generatePromptToPromptOutputEdges';

type GenerateAllEdgesProps = {
  promptInputs: PromptInput[];
  prompts: Prompt[];
  promptOutputs: PromptOutputAndNameId[];
  slides: Slide[];
};

export const generateAllEdges = ({
  promptInputs,
  prompts,
  promptOutputs,
  slides,
}: GenerateAllEdgesProps) => {
  const flattedPromptOutputs = flattenPromptOutputs(promptOutputs);

  return [
    ...generatePromptInputToPromptEdges({ promptInputs, prompts }),
    ...generatePromptToPromptOutputEdges({ flattedPromptOutputs }),
    ...generatePromptOutputToPromptEdges({ prompts }),
    ...generatePromptOutputToSlideEdges({ slides }),
  ];
};
